import { Divider, Flex, Typography } from 'antd';
import styled from 'styled-components';

export const CardWrapper = styled(Flex).attrs({
  flex: 1,
  vertical: true,
})`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colorBgContainer};
  border: 1px solid ${({ theme }) => theme.colorBorderSecondary};
`;

export const SectionDescription = styled(Typography.Text)<{ $isDisabled?: boolean }>`
  color: ${({ theme, $isDisabled }) => ($isDisabled ? theme.colorTextDisabled : theme.colorTextDescription)} !important;
`;

export const HeaderWrapper = styled(Flex).attrs({
  flex: 1,
})`
  padding: 16px 24px;
  color: ${({ theme }) => theme.colorTextHeading};
  font-size: 17px;
  font-weight: 500;
`;

export const HeaderTitle = styled(Typography.Title).attrs({
  level: 5,
})`
  width: 100%;
  color: ${({ theme }) => theme.colorTextHeading};
`;

interface ContentWrapperProps {
  $withoutCard?: boolean;
  $isDesktop?: boolean;
  $withoutPadding?: boolean;
}

export const ContentWrapper = styled(Flex).attrs<ContentWrapperProps>({
  flex: 1,
})`
  padding: ${({ $withoutCard, $isDesktop, $withoutPadding }) =>
    $withoutPadding ? 0 : $withoutCard && !$isDesktop ? '0 24px 24px' : '24px'};
  max-width: 100%;
  overflow: hidden;
  position: relative;
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
`;

interface ChildrenWrapperProps {
  $verticallyCentered?: boolean;
  $horizontallyCentered?: boolean;
  $horizontal?: boolean;
}

export const ChildrenWrapper = styled(Flex).attrs<ChildrenWrapperProps>(
  ({ $verticallyCentered, $horizontallyCentered, $horizontal }) => ({
    flex: 5,
    vertical: !$horizontal,
    gap: 16,
    justify: $verticallyCentered ? 'center' : 'initial',
    align: $horizontallyCentered ? 'center' : 'initial',
  }),
)``;

interface TitleProps {
  $isDisabled?: boolean;
}

export const Title = styled(Typography.Title).attrs({
  level: 5,
})<TitleProps>`
  color: ${({ theme, $isDisabled }) => ($isDisabled ? theme.colorTextDisabled : theme.colorText)} !important;
  margin-bottom: 4px;
`;

export const RenderCardWrapper = styled.div`
  width: 100%;
`;

interface WrapperProps {
  $isDesktop: boolean;
  $isDisabled?: boolean;
  $isCard?: boolean;
}

export const Wrapper = styled(Flex).attrs<WrapperProps>(({ $isDesktop }) => ({
  vertical: !$isDesktop,
  gap: 20,
}))`
  width: 100%;
  padding: ${({ $isDesktop }) => ($isDesktop ? '0 12px 0px 24px' : 0)};
  .ant-typography {
    margin-bottom: 0;
  }
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    opacity: 0.8;
    pointer-events: none;
  `}
  ${({ $isCard, theme }) =>
    $isCard &&
    `
    .ant-flex {
      border-color: ${theme.colorBorder};
      border-radius: 8px;
    }
    .ant-flex:hover {
      border-color: ${theme.colorPrimaryBorder};
    }
    .setting-card-content-wrapper:hover {
      background-color: ${theme.colorPrimaryBg};
      .connection-default-tag {
        background-color: ${theme.colorPrimaryBgHover};
        color: ${theme.colorPrimaryActive};
      }
      .connection-make-default-button {
        color: ${theme.colorText};
        background-color: ${theme.colorPrimaryBgHover};
        cursor: pointer;
      }
    }
  `}
`;

interface TitleWrapperProps {
  $isDesktop: boolean;
}

export const TitleWrapper = styled(Flex).attrs<TitleWrapperProps>({
  flex: 2,
  vertical: true,
})`
  max-width: ${({ $isDesktop }) => ($isDesktop ? '250px' : '100%')};
  width: 100%;
`;
